export default {
  state: {
    menu: {
      left: false,
      leftmini: false,
      rigth: false,
      toolbar: false,
      toolbarBehavior: false,
      reloadableKey: new Date().getTime()
    },
  },
  mutations: {
    refreshReloadableMenuKey(state) {
      state.menu.reloadableKey = new Date().getTime()
    },
    updateMenuState(state, menu) {
      state.menu = Object.assign(state.menu, menu);
    },
    toggleMenul(state) {
      if (this.getters.isMobileSize) {
        state.menu.left = !state.menu.left
      } else {
        state.menu.leftmini = !state.menu.leftmini
      }
    },
    toggleMenur(state) {
      state.menu.rigth = !state.menu.rigth
    },
  },
}